var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aha-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.openUpgrade()}}},[_vm._v("\n  Upgrade now\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }